"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setActiveRecordId = exports.addWizardNumber = exports.updateUserInfoErr = exports.updateUserInfo = exports.unBindAccount = exports.updatePwd = exports.setHttpErrInfo = exports.setReqStatus = exports.getEmailCode = exports.setUserTimeZone = exports.setUserAvatarColor = exports.setUserAvatar = exports.signOut = exports.setNickName = exports.setLoading = exports.setIsLogin = exports.setUserMe = exports.getUserMe = exports.setHomeErr = exports.setUsedInviteReward = exports.setRegisterStatus = exports.setIsCode = exports.getRegisterCode = exports.signIn = void 0;
const api_1 = require("../../../../exports/api");
const space_1 = require("../../../space/store/actions/space");
const config_1 = require("../../../../config");
const actions = __importStar(require("../../../shared/store/action_constants"));
/**
 * login
 * @param username
 * @param password
 */
const signIn = (data) => {
    return (dispatch) => {
        api_1.Api.signIn(data).then(res => {
            const { success, message, code } = res.data;
            if (success) {
                dispatch((0, exports.getUserMe)());
                dispatch((0, exports.setHomeErr)(null));
                dispatch((0, exports.setHttpErrInfo)(null));
            }
            else {
                dispatch((0, exports.setHomeErr)({
                    code,
                    msg: message,
                }));
            }
        }, err => {
            console.log('API.signIn error', err);
        });
    };
};
exports.signIn = signIn;
/**
 * get verify code in register
 * @param phone
 */
const getRegisterCode = (areaCode, phone) => {
    return (dispatch) => {
        api_1.Api.getSmsCode(areaCode, phone, config_1.ConfigConstant.REGISTER_ACCOUNT).then(res => {
            const { code, message } = res.data;
            dispatch((0, exports.setHomeErr)({
                code,
                msg: message,
            }));
        }, err => {
            console.log('API.getSmsCode error', err);
        });
    };
};
exports.getRegisterCode = getRegisterCode;
/**
 * get current state of getting verify code
 * @param status current state
 */
const setIsCode = (status) => {
    return {
        type: actions.SET_IS_CODE,
        payload: status,
    };
};
exports.setIsCode = setIsCode;
/**
 * set current register state
 * @param status
 */
const setRegisterStatus = (status) => {
    return {
        type: actions.SET_REGISTER_STATUS,
        payload: status,
    };
};
exports.setRegisterStatus = setRegisterStatus;
/**
 * set state of whether used invite award
 * @param status new state
 */
const setUsedInviteReward = (status) => {
    return {
        type: actions.SET_USED_INVITE_REWARD,
        payload: status,
    };
};
exports.setUsedInviteReward = setUsedInviteReward;
/**
 * set error message on login
 * @param err
 */
const setHomeErr = (err) => {
    return {
        type: actions.SET_HOME_ERR,
        payload: err,
    };
};
exports.setHomeErr = setHomeErr;
/**
 * get my user info
 */
const getUserMe = (locateIdMap = {}) => {
    return (dispatch, getState) => {
        api_1.Api.getUserMe(locateIdMap).then(res => {
            const { success, data } = res.data;
            if (success) {
                const { needCreate, needPwd } = data;
                if (needPwd || needCreate) {
                    dispatch((0, exports.setUserMe)(data));
                    return;
                }
                dispatch((0, exports.setIsLogin)(true));
                dispatch((0, exports.setUserMe)(data));
                const state = getState();
                if (!state.space.activeId) {
                    dispatch((0, space_1.setActiveSpaceId)(data.spaceId));
                }
            }
            else {
                dispatch((0, exports.setIsLogin)(false));
            }
        }, err => {
            console.log('API.getUserMe error', err);
        });
    };
};
exports.getUserMe = getUserMe;
/**
 * set my user info
 * @param user
 */
const setUserMe = (user) => {
    return {
        type: actions.SET_USER_ME,
        payload: user,
    };
};
exports.setUserMe = setUserMe;
/**
 * set state of getting user info
 * @param status
 */
const setIsLogin = (status) => {
    return {
        type: actions.SET_IS_LOGIN,
        payload: status,
    };
};
exports.setIsLogin = setIsLogin;
/**
 * set loading state
 * @param status
 */
const setLoading = (status) => {
    return {
        type: actions.SET_LOADING,
        payload: status,
    };
};
exports.setLoading = setLoading;
/**
 * set nickname
 * @param nickName
 */
const setNickName = (nickName) => {
    return {
        type: actions.SET_NICKNAME,
        payload: nickName,
    };
};
exports.setNickName = setNickName;
/**
 * logout
 */
const signOut = () => {
    return {
        type: actions.SIGN_OUT,
    };
};
exports.signOut = signOut;
/**
 * set user avatar
 * @param avatar avatar url
 */
const setUserAvatar = (data) => {
    return {
        type: actions.SET_USER_AVATAR,
        payload: data,
    };
};
exports.setUserAvatar = setUserAvatar;
/**
 * set user avatar
 * @param avatar avatar url
 */
const setUserAvatarColor = (data) => {
    return {
        type: actions.SET_USER_AVATAR_COLOR,
        payload: data,
    };
};
exports.setUserAvatarColor = setUserAvatarColor;
/**
 * set user timezone
 * @param data timezone
 */
const setUserTimeZone = (data) => {
    return {
        type: actions.SET_USER_TIMEZONE,
        payload: data,
    };
};
exports.setUserTimeZone = setUserTimeZone;
/**
 * get verify code by email
 * @param email
 */
const getEmailCode = (email, type = 1) => {
    return (dispatch) => {
        api_1.Api.getEmailCode(email, type).then(res => {
            const { code, message } = res.data;
            dispatch((0, exports.setHomeErr)({
                code,
                msg: message,
            }));
        }, err => {
            console.log('API.getEmailCode error', err);
        });
    };
};
exports.getEmailCode = getEmailCode;
/**
 * set request status
 * @param status
 */
const setReqStatus = (status) => {
    return {
        type: actions.SET_REQ_STATUS,
        payload: status,
    };
};
exports.setReqStatus = setReqStatus;
/**
 * set http request error message
 * @param info
 */
const setHttpErrInfo = (info) => {
    return {
        type: actions.SET_HTTP_ERR_INFO,
        payload: info,
    };
};
exports.setHttpErrInfo = setHttpErrInfo;
/**
 * update password
 */
const updatePwd = (password) => {
    return (dispatch) => {
        api_1.Api.updatePwd(password).then(res => {
            const { success, code, message: msg } = res.data;
            if (success) {
                dispatch((0, exports.getUserMe)());
            }
            else {
                dispatch((0, exports.setHomeErr)({
                    code,
                    msg,
                }));
            }
        }, err => {
            console.log('API.updatePwd error', err);
        });
    };
};
exports.updatePwd = updatePwd;
/**
 * unbind account
 */
const unBindAccount = (type) => {
    return (dispatch) => {
        api_1.Api.unBindAccount(type).then(res => {
            const { success, code, message: msg } = res.data;
            if (success) {
                dispatch((0, exports.getUserMe)());
            }
            else {
                dispatch((0, exports.setHomeErr)({
                    code,
                    msg,
                }));
            }
        }, err => {
            console.log('API.unbindAccount error', err);
        });
    };
};
exports.unBindAccount = unBindAccount;
/**
 * update user info
 */
const updateUserInfo = (info) => {
    return {
        type: actions.UPDATE_USERINFO,
        payload: info,
    };
};
exports.updateUserInfo = updateUserInfo;
const updateUserInfoErr = (err) => {
    return {
        type: actions.UPDATE_USERINFO_ERR,
        payload: err,
    };
};
exports.updateUserInfoErr = updateUserInfoErr;
const addWizardNumber = (wizardId) => {
    return {
        type: actions.ADD_WIZARD_NUMBER,
        payload: wizardId,
    };
};
exports.addWizardNumber = addWizardNumber;
const setActiveRecordId = (activeRecordId) => {
    return {
        type: actions.SET_ACTIVE_RECORD_ID,
        payload: activeRecordId
    };
};
exports.setActiveRecordId = setActiveRecordId;
//# sourceMappingURL=user.js.map